const util = {
    countDown: function (target, end) {
        console.log(...arguments)
        let usTime;
        let result;
        let interval = null;
        const startTime = '2023-03-28 23:59:59';
        const endTime = '2023-03-30 15:59:59';
        let timestamp = new Date(end)
        function getServerDate() {
            $.ajax({
                async: false, type: "OPTIONS", url: "/", complete: function (x) {
                    usTime = getUsTime(x.getResponseHeader("Date"))
                }
            })
        }
        let u = navigator.userAgent, isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      	let isSafari = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))

        function formatTimeStamp(date){
            return Date.parse(new Date(date.replace(/-/g,'/')));
        }


        if (isIOS || isSafari) {
            timestamp = formatTimeStamp(end) //这个是ios操作系统
        }
        function getUsTime(date) {
            let d = new Date(date);
            let timezone = 8; //目标时区时间
            let offset_GMT = d.getTimezoneOffset();
            let nowDate = d.getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
            let targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);
            // console.log(targetDate)
            return targetDate
        }
        getServerDate()

        if (+usTime < +timestamp) {
            interval = setInterval(countDown, 1000)
        }

        function countDown() {
            /*封装减1秒的函数*/
            if (result > 1) {
                result = result - 1;
                let second = Math.floor(result % 60);     // 计算秒 ，取余  
                let minite = Math.floor((result / 60) % 60); //计算分 ，换算有多少分，取余，余出多少秒
                let hour = Math.floor((result / 3600)); //计算小时，换算有多少小时，取余，24小时制除以24，余出多少小时
                let day = Math.floor(result / (3600 * 24));  //计算天 ，换算有多少天
                // <span style="display: ${day > 0 ? 'inline-block' : 'none'}">${day > 0 ? day : ''}d : </span>

                let tem = `
               <div>
                 <span>
                    <span class="count-num">${hour < 10 ? '0' + hour : hour}</span>
                    <span>H : </span>
                </span>
                 <span>
                    <span class="count-num">${minite < 10 ? '0' + minite : minite}</span>
                    <span>M : </span>
                </span>
                 <span>
                    <span class="count-num">${second < 10 ? '0' + second : second}</span>
                    <span>S</span>
                </span>
               </div>
           `
                $(target).html(tem)
            } else {
                if (+usTime > +timestamp) {
                    window.clearInterval(interval);//这里可以添加倒计时结束后需要执行的事件
                    $(target).html('')
                } else {
                    getServerDate()
                    result = Math.floor(+timestamp - +usTime) / 1000;
                }
            }

        }
    },
    setLocation: function () {
        const isCollection = $('body').hasClass('template-collection')
        if (!isCollection) return false

        $('body').click(function () {
            const _top = $(window).scrollTop()
            localStorage.setItem('location_', _top)
        })
    },
    scrollToHistory: function () {
        const isCollection = $('body').hasClass('template-collection')
        if (isCollection) {
            const _top = localStorage.getItem('location_');
            const isSourceToPDP = localStorage.getItem('source');
            localStorage.removeItem('source')
            $("html, body").animate({ scrollTop: _top }, 600);

        }
    },
    apiPost: function (url, data, cb) {
        const xhr = new XMLHttpRequest()
        xhr.open('POST', url, true);
        xhr.responseType = 'json'
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = function (e) {
            if (xhr.readyState == 4) {
                cb(xhr.response)
            }
        };
    },
    isMobile: function () {
        let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        return flag;
    },
    getPageType: function () {
        if ($('body').hasClass('template-index')) {
            return 'home'
        } else if ($('body').hasClass('template-product')) {
            return 'product'
        } else if ($('body').hasClass('template-product')) {
            return 'product'
        } else if ($('body').hasClass('template-collection')) {
            return 'collection'
        } else if ($('body').hasClass('template-search')) {
            return 'search'
        } else if ($('body').hasClass('template-search')) {
            return 'search'
        } else if ($('body').hasClass('template-customers-account')) {
            return 'account'
        } else if (location.href.indexOf('wishlist') > -1) {
            return 'wishlist'
        } else if (location.href.indexOf('page') > -1) {
            return 'page'
        } else {
            return 'other'
        }
    },
    getUserInfo: function () {
        return {
            device_os: navigator.userAgent,
            region: localStorage.getItem('T4Currency')? localStorage.getItem('T4Currency') : $('#nt_wrapper').data('currency') ? $('#nt_wrapper').data('currency') :'usd',
            account_ident: localStorage.getItem('account_ident') || null
        }
    },
    handleLang: function (el, attrName='href') {
        const url = location.href;
        const match = url.match(/https:\/\/urbanrevivo\.com\/([a-z]{2})/); // 匹配 URL 中的两位小写字母
        const languageCode = match ? match[1] : "";
        console.log('languageCode', languageCode)
        if (languageCode) {
            $(el).attr(attrName, function(i, val) {
                const isHaveLang = val.slice(0, 3);
                if (isHaveLang.indexOf(languageCode) > -1) {
                    return val; 
                } else {
                    return '/' + languageCode + val; 
                }
            });
        }
    }
}